module.exports = __webpack_public_path__ + "media/images/world-banner@2x-1183271edbe278fac12a704eea4f70bb.png";